import './Prestations.scss';
import { Button, Theme } from '../components/button/Button';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { isDesktop } from 'react-device-detect';
import shiatsuImg from '../assets/candles.png';
import signatureImg from '../assets/candles-2.jpg';
import japaneseLiftingImg from '../assets/face-massage.jpg';
import kobidoInspiredImg from '../assets/face-massage-3.jpg';
import contactInfo from '../contact-info.json';
import dienChanImg from '../assets/lotus.jpg';
import drainingImg from '../assets/face-massage-4.jpg';
import tuiNaImg from '../assets/spa.jpg';
import hinokiboImg from '../assets/relax.jpg';
import intrabuccalImg from '../assets/zen.jpg';
const prestationsMap = new Map([
  [
    'signature',
    {
      title: 'Le massage signature de Lilia',
      price: 150,
      duration: 90,
      image: signatureImg,
    },
  ],
  [
    'japanese-lifting',
    {
      title: 'Lifting massage japonais',
      price: 120,
      duration: 90,
      image: japaneseLiftingImg,
    },
  ],
  [
    'kobido-inspired',
    {
      title: 'Massage japonais inspiration Kobido',
      price: 120,
      duration: 60,
      image: kobidoInspiredImg,
    },
  ],
  [
    'shiatsu',
    {
      title: 'Shiatsu du visage',
      price: 120,
      duration: 60,
      image: shiatsuImg,
    },
  ],
  [
    'draining',
    {
      title: 'Modelage drainant',
      price: 120,
      duration: 45,
      image: drainingImg,
    },
  ],
  [
    'hinokibo',
    {
      title: 'Hinokibo',
      price: 120,
      duration: 45,
      image: hinokiboImg,
    },
  ],
  [
    'tui-na',
    {
      title: 'Tui Na facial',
      price: 120,
      duration: 45,
      image: tuiNaImg,
    },
  ],
  [
    'intrabuccal',
    {
      title: 'Massage intrabuccal',
      price: 120,
      duration: 45,
      image: intrabuccalImg,
    },
  ],
  [
    'dien-chan',
    {
      title: 'Dien Chan',
      price: 120,
      duration: 45,
      image: dienChanImg,
    },
  ],
]);

export function Prestations() {
  return (
    <section id="prestations" className="prestations-carousel">
      <Swiper
        navigation={window.innerWidth >= 1024}
        pagination={true}
        modules={[Navigation, Pagination]}
        loop={true}
      >
        {[...prestationsMap.entries()].map(([key, prestation]) => (
          <SwiperSlide key={key}>
            <PrestationCard prestation={prestation} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

function PrestationCard({ prestation }: { prestation: Prestation }) {
  return (
    <div className="prestation-card">
      <div className="prestation-description">
        <h1 className="lato-thin mb-0 title">{prestation.title}</h1>
        <h3 className="lato-thin mb-0">
          {prestation.duration} min | {prestation.price} €
        </h3>
        <a href={contactInfo.bookingPage}>
          <Button label="Prendre un rendez-vous" theme={Theme.LIGHT} />
        </a>
      </div>
      {isDesktop && (
        <img
          src={prestation.image}
          alt={prestation.title}
          className="prestation-picture"
        />
      )}
    </div>
  );
}
interface Prestation {
  title: string;
  duration: number;
  price: number;
  image: string;
}
